module.exports = __webpack_public_path__ + "img/shogi_2021_pack_4_0004.55f7e24b.png";